module.exports = __webpack_public_path__ + "img/fachada.b3d7e96f.webp";